{
  "home": {
    "heroStop": "停止人类狩猎",
    "heroSave": "拯救赫尔松",
    "heroTitle1": "人类",
    "heroTitle2": "不是猎物",
    "heroDate": "12月13日、14日",
    "worldwideRally": "全球集会",
    "heroHashtags": "#HumansAreNotTargets #StopHumanSafari #SaveKherson",
    "infoText": "自2024年夏天以来，俄罗斯军队使用小型无人机在赫尔松及乌克兰其他前线城市的街道上追猎、杀害并恐吓平民。<bold>人类狩猎必须停止。你可以提供帮助。</bold>加入全球数千人，共同要求停止这一战争罪行。",
    "seeGallery": "查看全球海报",
    "comingSoon": "更多地点即将公布",
    "december": "十二月",
    "dec": "12月",
    "october": "十月",
    "oct": "10月",
    "september": "九月",
    "sep": "9月",
    "schedule9": "9日",
    "schedule10": "10日",
    "schedule11": "11日",
    "schedule12": "12日",
    "schedule13": "13日",
    "schedule14": "14日",
    "schedule16": "16日",
    "schedule18": "18日",
    "schedule20": "20日",
    "schedule1": "1日",
    "schedule2": "2日",
    "schedule3": "3日",
    "schedule4": "4日",
    "schedule5": "5日",
    "schedule25": "25日",
    "schedule26": "26日",
    "schedule27": "27日",
    "schedule28": "28日",
    "schedule29": "29日",
    "schedule30": "30日",
    "schedule31": "31日",
    "scheduleTBC": "日期确认中……",
    "recommendationsTitle": "联合国委员会的建议",
    "recommendationsRussia": "委员会建议俄罗斯联邦：",
    "rusRec1": "(a) 立即停止针对平民和民用设施的无人机袭击",
    "rusRec2": "(b) 立即停止一切在平民中散布恐怖的行为",
    "rusRec3": "(c) 确保所有参与针对平民的无人机袭击的肇事者承担责任",
    "recommendationsUNStates": "委员会建议其他国家以及区域和国际组织：",
    "statesRec1": "(a) 在财政上并以技术咨询的方式，向乌克兰政府及民间社会组织提供支持，以便为受害者及其家属提供全面援助；",
    "statesRec2": "(b) 对于其领土为从占领区被驱逐者目的地的第三国，应与乌克兰领事部门一道，采取必要努力以支持这些人员。",
    "reference": "参考资料",
    "linkUN": "联合国委员会：俄罗斯在乌克兰的“人类狩猎”是危害人类罪",
    "linkGuidelines": "联合国准则",
    "linkWiki": "维基百科"
  },
  "witnesses": {
    "title": " 我们正在收集目击者证词！",
    "email": "如果您来自赫尔松、尼科波尔、扎波罗热、苏梅或顿巴斯前线地区，并曾亲眼目睹“人类狩猎”，请将您的经历发送至 📧 <mail>khersonhumansafari@gmail.com</mail>，主题写“human safari”。",
    "type": " 如果您目睹了朋友或邻居在无人机袭击中丧生并希望分享您的叙述，请注明“目击者”；如果您本人遭到袭击，请注明“幸存者”。",
    "requirements": "<b>我们需要的信息：</b>城市/地点、袭击日期、简短叙述（3–6句；真实、第一人称）。",
    "honesty": "请诚实、简洁，避免提及敏感的军事位置——您可以保持匿名。",
    "media": "<b>有照片/视频？</b>请写“有照片/视频”。请勿附加文件——如需视觉材料，我们会与您联系。",
    "consent": "<b>发布同意：</b>“我同意将此故事公开发布在 HumanSafari.org 网站上。”"
  },
  "resources": {
    "title": "重要资源",
    "linkLibraryTitle": "链接库",
    "linkLibraryDesc": "200篇文章、报告、采访、第一手证词及媒体报道",
    "humanSafariMapTitle": "Tochnyi 人类狩猎地图",
    "humanSafariMapDesc": "一张记录赫尔松人类狩猎袭击的交互式地图，数据来自地方当局的公开报告，以及由 Tochnyi 团队完成地理定位的袭击影像。",
    "truthHoundsTitle": "Truth Hounds 报告",
    "truthHoundsDesc": "杀戮区：俄罗斯无人机如何摧残第聂伯河右岸",
    "hrwTitle": "人权观察关于赫尔松无人机袭击的报告",
    "hrwDesc": "人权观察报告",
    "unReportsTitle": "联合国人权理事会报告",
    "report1": "联合国报告 #1",
    "report3": "联合国报告 #3",
    "guidelines": "联合国准则",
    "wikipediaTitle": "维基百科",
    "english": "英文",
    "french": "法文",
    "documentaryTitle": "纪录片",
    "documentaryDesc": "www.khersonhumansafari.com"
  },
  "navbar": {
    "main": "12月13日–14日",
    "eyewitnesses": "证词",
    "rallies": "照片",
    "help": "已收复的赫尔松",
    "leftBank": "被占领的赫尔松",
    "action": "2025年12月",
    "oleshky": "全球集会 - 奥列什基",
    "menu": "菜单"
  },
  "leftBank": {
    "pageTitle": "无人机围困",
    "para1": "严重的人道主义紧急状况正影响着6000名平民——他们被困于遭占领的奥列什基、霍拉普里斯坦、旧兹布里夫卡和新兹布里夫卡（被占领的赫尔松州），处于无人机围困之下。奥列什基有1200至2000人。占领当局有义务为他们提供支援——然而俄罗斯军队却将他们用作人体盾牌，躲在这些居民身后，向对岸发动人类狩猎袭击。乌克兰当局和人道主义机构报告称，撤离和人道主义准入受到系统性阻挠。",
    "para2": "平民缺乏食物、饮用水、医疗、药品、电力、燃气和通信。道路布满地雷，无人机活动限制了人员流动。自5月26日以来，没有任何车辆能够进出。燃料和食物储备几近耗尽。",
    "meidasTitle": "Meidas Touch / Valor Media Network",
    "meidasVideo": "视频：《Kherson and Oleshky: Witnessing Genocide》（12分钟）",
    "meidasArticle": "文章：《The Kherson Region: How Russia Uses Civilians as a Tool of War》（阅读约5分钟）",
    "kyivPostTitle": "Kyiv Post",
    "kyivPostArticle": "文章：《Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate》（阅读约7分钟）",
    "tellPost": "并向他人讲述无人机围困",
    "callToHelp": "您可以提供帮助。方法如下",
    "donateIntro": "这些倡议提供高效、有针对性的直接帮助，援助已逃离奥列什基的人，以及在可能的情况下仍被困在那里的人。",
    "signTitle": "签署",
    "signSub": "请愿书",
    "petitionBy": "发起方：{{name}}",
    "petitions": {
      "euParliament": "欧洲议会——第1439/2026号请愿：要求为被困于俄罗斯占领下的乌克兰奥列什基、处于围困中的平民开辟人道主义撤离通道",
      "ukParliament": "英国议会——寻求开辟由英国主导的通往乌克兰奥列什基的人道主义援助通道"
    },
    "publicActionLead": "在你所在之处让无人机围困受到关注。",
    "organiseAction": "组织一次行动。",
    "policyBody": "乌克兰当局正与红十字国际委员会磋商，商讨从赫尔松地区被占定居点开辟人道主义撤离走廊，并确保食物、饮用水、药品、燃料和医疗援助的人道主义准入。截至6月初，尚无正常运作的撤离走廊或持续的人道主义准入机制。",
    "documentaryTitle": "奥列什基，纪录短片",
    "downloadTitle": "下载",
    "downloadSub": "图片"
  },
  "footer": {
    "addCityText": "如需添加您的城市，请发送电子邮件至：",
    "organiseText": "添加您的示威活动 - 请联系我们：",
    "contact": "联系方式："
  },
  "byCountry": "按国家查看",
  "byDate": "按日期查看",
  "countries": {
    "australia": "澳大利亚",
    "austria": "奥地利",
    "bulgaria": "保加利亚",
    "canada": "加拿大",
    "czechia": "捷克",
    "denmark": "丹麦",
    "estonia": "爱沙尼亚",
    "finland": "芬兰",
    "france": "法国",
    "georgia": "格鲁吉亚",
    "germany": "德国",
    "hungary": "匈牙利",
    "italy": "意大利",
    "japan": "日本",
    "mexico": "墨西哥",
    "netherlands": "荷兰",
    "norway": "挪威",
    "poland": "波兰",
    "romania": "罗马尼亚",
    "spain": "西班牙",
    "sweden": "瑞典",
    "southAfrica": "南非",
    "ukraine": "乌克兰",
    "unitedKingdom": "英国",
    "usa": "美国",
    "ireland": "爱尔兰",
    "belgium": "比利时"
  },
  "cities": {
    "alicante": {
      "city": "阿利坎特",
      "country": "西班牙",
      "time": "阿利坎特 - 西班牙，16:00 - 17:00",
      "location": "Auditorio la Concha, Explanada de España",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule13"
    },
    "barcelona": {
      "city": "巴塞罗那",
      "country": "西班牙",
      "time": "巴塞罗那 - 西班牙，12:00 - 14:00",
      "location": "Placa de Sant Jaume",
      "cleanTime": "12:00 - 14:00",
      "day": "schedule14"
    },
    "berkeley": {
      "city": "伯克利",
      "country": "美国",
      "time": "伯克利 - 美国，12:00 - 13:00",
      "location": "4th St.",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "berlin": {
      "city": "柏林",
      "country": "德国",
      "time": "柏林 - 德国，12:00",
      "location": "Tempelhofer Feld, entry Leinstr./corner of Oderstr.",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "bettendorf": {
      "city": "贝滕多夫",
      "country": "美国",
      "time": "贝滕多夫 - 美国，17:30 - 电影放映",
      "location": "Bettendorf Public Library",
      "cleanTime": "17:30 - 电影放映",
      "day": "schedule11"
    },
    "birmingham": {
      "city": "伯明翰",
      "country": "英国",
      "time": "伯明翰 - 英国，14:00 - 15:30",
      "location": "Baskerville House, Cambridge St.",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "bonn": {
      "city": "波恩",
      "country": "德国",
      "time": "波恩 - 德国，14:00 - 16:00",
      "location": "Poststraße, in front of the Hauptbahnhof",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "bremen": {
      "city": "不来梅",
      "country": "德国",
      "time": "不来梅 - 德国，15:00 - 18:00",
      "location": "Bahnhofsvorplatz",
      "cleanTime": "15:00 - 18:00",
      "day": "schedule14"
    },
    "budapest": {
      "city": "布达佩斯",
      "country": "匈牙利",
      "time": "布达佩斯 - 匈牙利，待定",
      "location": "",
      "cleanTime": "待定",
      "day": "scheduleTBC"
    },
    "chicago": {
      "city": "芝加哥",
      "country": "美国",
      "time": "芝加哥 - 美国，13:00 - 15:00",
      "location": "410 N. Michigan ave. (Wrigley building)",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "constanta": {
      "city": "康斯坦察",
      "country": "罗马尼亚",
      "time": "康斯坦察 - 罗马尼亚，待定",
      "location": "",
      "cleanTime": "待定",
      "day": "scheduleTBC"
    },
    "copenhagen": {
      "city": "哥本哈根",
      "country": "丹麦",
      "time": "哥本哈根 - 丹麦，14:00",
      "location": "Axeltorv",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "dallas": {
      "city": "达拉斯",
      "country": "美国",
      "time": "达拉斯 - 美国，12:00 - 13:00",
      "location": "Dallas City Hall Plaza",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "denver": {
      "city": "丹佛",
      "country": "美国",
      "time": "丹佛 - 美国，12:00",
      "location": "Colorado Capitol Building, West Steps",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "edinburgh": {
      "city": "爱丁堡",
      "country": "英国",
      "time": "爱丁堡 - 英国，13:00 - 15:00",
      "location": "Duke of Wellington Monument",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule13"
    },
    "fortWorth": {
      "city": "沃斯堡",
      "country": "美国",
      "time": "沃斯堡 - 美国，14:00 - 15:00",
      "location": "Tarrant County Courthouse",
      "cleanTime": "14:00 - 15:00",
      "day": "schedule14"
    },
    "hamburg": {
      "city": "汉堡",
      "country": "德国",
      "time": "汉堡 - 德国，14:00 - 16:00",
      "location": "Mönckebergbrunnen (Mönckebergstraße)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule20"
    },
    "houghton": {
      "city": "霍顿（密歇根州）",
      "country": "美国",
      "time": "霍顿（密歇根州） - 美国，15:00",
      "location": "Portage Lake Lift Bridge",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "helsinki": {
      "city": "赫尔辛基",
      "country": "芬兰",
      "time": "赫尔辛基 - 芬兰，17:00 - 18:00",
      "location": "Narinkkatori",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule16"
    },
    "izumo14": {
      "city": "出云",
      "country": "日本",
      "time": "出云 - 日本，13:00",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "13:00",
      "day": "schedule14"
    },
    "izumo20": {
      "city": "出云",
      "country": "日本",
      "time": "出云 - 日本",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "",
      "day": "schedule20"
    },
    "kamloops": {
      "city": "坎卢普斯（不列颠哥伦比亚省）",
      "country": "加拿大",
      "time": "坎卢普斯（不列颠哥伦比亚省） - 加拿大，15:00 - 16:00",
      "location": "City Hall",
      "cleanTime": "15:00 - 16:00",
      "day": "schedule13"
    },
    "kyiv": {
      "city": "基辅",
      "country": "乌克兰",
      "time": "基辅 - 乌克兰，17:00 - 18:00",
      "location": "Maidan Nezalezhnosti",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule14"
    },
    "leipzig": {
      "city": "莱比锡",
      "country": "德国",
      "time": "莱比锡 - 德国，12:00 - 13:00",
      "location": "Willy Brandt Platz",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "london": {
      "city": "伦敦",
      "country": "英国",
      "time": "伦敦 - 英国，18:30 - 电影放映",
      "location": "Ukrainian House, 154 Holland Park Avenue",
      "cleanTime": "18:30 - 电影放映",
      "day": "schedule12"
    },
    "losAngeles": {
      "city": "洛杉矶",
      "country": "美国",
      "time": "洛杉矶 - 美国，15:30",
      "location": "4051 Melrose Ave",
      "cleanTime": "15:30",
      "day": "schedule14"
    },
    "malaga": {
      "city": "马拉加",
      "country": "西班牙",
      "time": "马拉加 - 西班牙，18:00 - 电影放映",
      "location": "Maydan - Centro Historico Cultural Ukraniano",
      "cleanTime": "18:00 - 电影放映",
      "day": "schedule13"
    },
    "manchester": {
      "city": "曼彻斯特",
      "country": "英国",
      "time": "曼彻斯特 - 英国，14:00 - 15:30",
      "location": "St Peter's Square Emmeline Pankhurst Memorial",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "mexicoCity": {
      "city": "墨西哥城",
      "country": "墨西哥",
      "time": "墨西哥城 - 墨西哥，11:00",
      "location": "Alameda Central. \"Americas\" fountain (between Hemiciclo Juárez and Kiosk)",
      "cleanTime": "11:00",
      "day": "schedule14"
    },
    "milan": {
      "city": "米兰",
      "country": "意大利",
      "time": "米兰 - 意大利，15:00",
      "location": "The Duomo di Milano",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "munich": {
      "city": "慕尼黑",
      "country": "德国",
      "time": "慕尼黑 - 德国，17:00 - 19:00",
      "location": "Odeonsplatz",
      "cleanTime": "17:00 - 19:00",
      "day": "schedule14"
    },
    "newYork13": {
      "city": "纽约",
      "country": "美国",
      "time": "纽约 - 美国，16:00",
      "location": "Times Square",
      "cleanTime": "16:00",
      "day": "schedule13"
    },
    "newYork14": {
      "city": "纽约",
      "country": "美国",
      "time": "纽约 - 美国，13:00 - 14:00",
      "location": "Times Square",
      "cleanTime": "13:00 - 14:00",
      "day": "schedule14"
    },
    "nienburg": {
      "city": "尼恩堡（威悉河）",
      "country": "德国",
      "time": "尼恩堡（威悉河） - 德国，17:00",
      "location": "Stettiner Str.2A",
      "cleanTime": "17:00",
      "day": "schedule13"
    },
    "oslo": {
      "city": "奥斯陆",
      "country": "挪威",
      "time": "奥斯陆 - 挪威，12:00 - 13:00",
      "location": "Eidsvoll Plass, Stortinget",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule14"
    },
    "ostersund": {
      "city": "厄斯特松德",
      "country": "瑞典",
      "time": "厄斯特松德 - 瑞典，11:00 - 14:00",
      "location": "Stortorget（主广场）",
      "cleanTime": "11:00 - 14:00",
      "day": "schedule13"
    },
    "ottawa12": {
      "city": "渥太华",
      "country": "加拿大",
      "time": "渥太华 - 加拿大，12:30 - 13:30",
      "location": "russian Embassy",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule12"
    },
    "ottawa13": {
      "city": "渥太华",
      "country": "加拿大",
      "time": "渥太华 - 加拿大，12:00",
      "location": "US Embassy",
      "cleanTime": "12:00",
      "day": "schedule13"
    },
    "paris": {
      "city": "巴黎",
      "country": "法国",
      "time": "巴黎 - 法国，15:30",
      "location": "Square Taras Chevchenko -> Fontaine Saint-Michel (march)",
      "cleanTime": "15:30",
      "day": "schedule13"
    },
    "plovdiv": {
      "city": "普罗夫迪夫",
      "country": "保加利亚",
      "time": "普罗夫迪夫 - 保加利亚，16:00 - 17:00",
      "location": "by the Levski House",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule14"
    },
    "prague": {
      "city": "布拉格",
      "country": "捷克",
      "time": "布拉格 - 捷克，14:00",
      "location": "Palackého Square",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "rosendal": {
      "city": "罗森达尔",
      "country": "南非",
      "time": "罗森达尔 - 南非，11:00",
      "location": "South African Police Service offices",
      "cleanTime": "11:00",
      "day": "schedule13"
    },
    "sanAndres": {
      "city": "圣安德烈斯（特内里费）",
      "country": "西班牙",
      "time": "圣安德烈斯（特内里费） - 西班牙，13:00",
      "location": "--",
      "cleanTime": "13:00",
      "day": "schedule13"
    },
    "sanDiego": {
      "city": "圣地亚哥",
      "country": "美国",
      "time": "圣地亚哥 - 美国，14:00 - 16:00",
      "location": "El Cid Statue, Balboa Park",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "sanFrancisco": {
      "city": "旧金山",
      "country": "美国",
      "time": "旧金山 - 美国，14:00",
      "location": "Ferry Plaza, Embarcadero",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "schwerin": {
      "city": "什未林",
      "country": "德国",
      "time": "什未林 - 德国，19:00 - 电影放映",
      "location": "Internationales Haus, Ziegenmarkt 4",
      "cleanTime": "19:00 - 电影放映",
      "day": "schedule13"
    },
    "seattle": {
      "city": "西雅图",
      "country": "美国",
      "time": "西雅图 - 美国，12:30 - 15:30",
      "location": "1005 E Union St.",
      "cleanTime": "12:30 - 15:30",
      "day": "schedule13"
    },
    "svetiVlas": {
      "city": "圣弗拉斯",
      "country": "保加利亚",
      "time": "圣弗拉斯 - 保加利亚，待定",
      "location": "",
      "cleanTime": "待定",
      "day": "scheduleTBC"
    },
    "sydney": {
      "city": "悉尼",
      "country": "澳大利亚",
      "time": "悉尼 - 澳大利亚，14:00",
      "location": "Sydney Town Hall",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "tallinn": {
      "city": "塔林",
      "country": "爱沙尼亚",
      "time": "塔林 - 爱沙尼亚，15:00 - 电影放映及集会",
      "location": "Sõprus Cinema, Vana-Posti tn.8",
      "cleanTime": "15:00 - 电影放映及集会",
      "day": "schedule13"
    },
    "tarragona": {
      "city": "塔拉戈纳",
      "country": "西班牙",
      "time": "塔拉戈纳 - 西班牙，18:30",
      "location": "Balcó Mediterrani",
      "cleanTime": "18:30",
      "day": "schedule14"
    },
    "theHague": {
      "city": "海牙",
      "country": "荷兰",
      "time": "海牙 - 荷兰，13:00 - 15:00",
      "location": "In front of the Peace Palace / ICC",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "tbilisi": {
      "city": "第比利斯",
      "country": "格鲁吉亚",
      "time": "第比利斯 - 格鲁吉亚，21:00",
      "location": "Tbilisi",
      "cleanTime": "21:00",
      "day": "schedule14"
    },
    "tranas": {
      "city": "特拉诺斯",
      "country": "瑞典",
      "time": "特拉诺斯 - 瑞典，11:00 - 13:00, 13:00",
      "location": "Storgatan 49 (Kultivera)",
      "cleanTime": "11:00 - 13:00, 13:00",
      "day": "schedule13"
    },
    "vienna": {
      "city": "维也纳",
      "country": "奥地利",
      "time": "维也纳 - 奥地利，16:00 - 18:00",
      "location": "Stock im Eisen Platz (next to Stephansdom)",
      "cleanTime": "16:00 - 18:00",
      "day": "schedule14"
    },
    "washingtonDC": {
      "city": "华盛顿特区",
      "country": "美国",
      "time": "华盛顿特区 - 美国，12:30 - 13:30",
      "location": "The White House",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule14"
    },
    "wroclaw": {
      "city": "弗罗茨瓦夫",
      "country": "波兰",
      "time": "弗罗茨瓦夫 - 波兰，13:00",
      "location": "Freedom Square (direction People's Forum of Music)",
      "cleanTime": "13:00",
      "day": "schedule14"
    }
  },
  "help": {
    "organise": "联系方式：",
    "email": "khersonhumansafari@gmail.com",
    "actionEmail": "antihumansafari@gmail.com",
    "share": "分享到 {{platform}}",
    "website": "网站",
    "facebook": "Facebook",
    "x": "X",
    "youtube": "YouTube",
    "bluesky": "Bluesky",
    "donate": "捐款",
    "donateIntro": "这些倡议提供高效、有针对性的直接帮助，保护赫尔松平民免遭“人类狩猎”。",
    "shareTitle": "传播信息",
    "filmScreening": "组织放映纪录片《赫尔松人类狩猎》：",
    "howItStarted": "事情的起源",
    "khs": {
      "name": "Kherson Human Safari",
      "desc": "记者兼电影人扎丽娜·扎布里斯基（Zarina Zabrisky）领导了这场全球集会，并执导了纪录片《赫尔松人类狩猎》。"
    },
    "fellas": {
      "name": "Fellas4Europe",
      "desc": "为赫尔松街道提供平民保护——保护平民免受无人机袭击。",
      "foodDesc": "食品援助。",
      "foodNote": "捐款时请在备注中填写“Food for Cherson”。"
    },
    "ahs": {
      "name": "Anti Human Safari Project",
      "desc": "为赫尔松的志愿者和应急服务人员提供无人机探测器和防护背心。"
    },
    "pageTitle": "停止人类狩猎",
    "sectionIntro": "自2024年夏天以来，俄罗斯军队使用小型无人机在赫尔松及乌克兰其他前线城市的街道上追猎、杀害并恐吓平民。",
    "sectionIntro2": "这是一场系统而蓄意的谋杀行动：俄罗斯无人机操作员公然把受害者的影像发布到 Telegram 频道上炫耀。2025年5月，联合国认定人类狩猎是一项持续进行的战争罪。",
    "sectionIntro3": "所做的努力远远不够。人类狩猎必须停止。",
    "sectionIntroBold": "你可以提供帮助。方法如下",
    "step2Title": "组织行动",
    "step3Title": "告诉他人",
    "step3Para": "使用话题标签",
    "step3ParaPost": "并向他人讲述人类狩猎",
    "instagram": "Instagram",
    "step2Bullet1": "电影放映",
    "step2Bullet2": "一场公开行动",
    "step2Bullet3": "媒体报道",
    "publicActionLead": "在你所在之处让人类狩猎受到关注。",
    "reachOutPre": "您可以",
    "reachOut": "联系我们",
    "reachOutPost": "获取想法和资源",
    "newsCoverageLead": "通过你的媒体联系人。向他们讲述人类狩猎，以及它对当前和未来所有冲突地区构成的风险。",
    "putInTouchPre": "您也可以",
    "putInTouch": "直接把我们介绍给他们",
    "inform": "了解信息",
    "informSub": "让自己和他人了解",
    "policyTitle": "政策",
    "policyBody": "拟议的《LORA法案》（Liability for Operators and Responsible Authorities Act）将对整个责任链条实施制裁——从俄罗斯FPV无人机操作员和指挥官，到高级军事领导层，以及为针对平民的无人机生产和部署提供支持的制造商和供应商。",
    "policyHelp": "您可以在政策层面提供帮助？",
    "getInTouch": "联系我们",
    "disdict": {
      "title": "虚假信息词典",
      "link": "人类狩猎"
    },
    "kryla": {
      "name": "Kryla Foundation",
      "desc": "支持他们为奥列什基居民支付住宿和基本生活用品。"
    }
  },
  "action": {
    "intro": "我们以一场全球示威拉开序幕。现在你可以：",
    "helpLink": "在此提供帮助"
  },
  "accounts": {
    "heading": "目击证词"
  },
  "media": {
    "close": "关闭",
    "view": "查看媒体",
    "previous": "上一个",
    "next": "下一个",
    "andrushenkoCredit": "奥列克桑德尔·安德留先科，Vgoru 媒体摄影记者",
    "khersonPoliceCredit": "来自 @khersonpolice",
    "antypenkoCredit": "伊万·安蒂片科，来自赫尔松的摄影记者",
    "telegramChannelCredit": "由俄方“人类狩猎”Telegram 频道“从马里乌波尔到喀尔巴阡”发布",
    "fruitSellerDescription": "水果小贩遭光纤无人机追击",
    "burntCarDescription": "赫尔松一辆被烧毁的汽车",
    "bridgeAttackDescription": "一名少年在赫尔松一座桥下被 FPV 无人机杀害",
    "busAttackDescription": "针对公共交通的众多 FPV 无人机袭击之一",
    "fpvDroneDescription": "“人类狩猎”行动中出动的 FPV 无人机",
    "antiDroneNetsDescription": "赫尔松街道上张起防“人类狩猎”无人机的网",
    "firefighterDescription": "消防员在“人类狩猎”袭击后扑灭起火车辆，后方躺着一名受害者"
  },
  "follow": {
    "title": "关注",
    "subHumanSafari": "来自赫尔松、报道人类狩猎的优质信源",
    "subDroneSiege": "来自赫尔松、报道无人机围困的优质信源",
    "localPress": "当地乌克兰语媒体",
    "lang": {
      "english": "英语",
      "german": "德语",
      "ukrainian": "乌克兰语"
    },
    "language": "语言：{{list}}",
    "languages": "语言：{{list}}",
    "langSeparator": "、",
    "zabrisky": {
      "name": "扎丽娜·扎布里斯基（Zarina Zabrisky）",
      "desc": "常驻赫尔松的美国记者兼电影人，为 Byline Times 和 Euromaidan Press 供稿；纪录片《赫尔松人类狩猎》导演。"
    },
    "naber": {
      "name": "易卜拉欣·纳贝尔（Ibrahim Naber）",
      "desc": "德国《世界报》首席记者；定期报道赫尔松的人类狩猎。"
    },
    "kelley": {
      "name": "布伦丹·凯利（Brendan Kelley）",
      "desc": "撰写《Kherson Weekly》，持续记录俄军无人机对赫尔松及周边村庄平民的袭击。"
    },
    "vgoru": {
      "name": "Vgoru（《向上》）",
      "desc": "赫尔松州的独立媒体平台，报道炮火下与占领区的生活。"
    },
    "suspilne": {
      "name": "Suspilne 赫尔松",
      "desc": "乌克兰公共广播公司的赫尔松编辑部。"
    },
    "most": {
      "name": "MOST",
      "desc": "赫尔松当地通讯社，报道该市及全州。"
    }
  },
  "rallies": {
    "oleshky2026": {
      "heroStop": "停止无人机围困",
      "heroSave": "拯救奥列什基",
      "worldwideRally": "全球集会",
      "heroDate": "十月",
      "infoText1": "奥列什基、霍拉普里斯坦、旧兹布里夫卡和新兹布里夫卡的数千名平民被困于无人机围困之中。俄罗斯军队把他们当作人体盾牌，躲在他们身后向对岸发动人类狩猎无人机袭击。",
      "infoText2": "危机十分严峻：食物、水、医疗、药品、电力、燃气和通讯全面短缺。道路布满地雷，无人机活动限制了一切行动。<bold>你可以提供帮助。加入全球数千人，共同要求停止无人机围困。</bold>",
      "imageAlt": "在被摧毁的奥列什基，一只饥饿的狗在人骨间觅食，红色天空中布满无人机，上方写着 Stop Russian Drone Siege",
      "demandsTitle": "我们呼吁：",
      "demand1": "建立通往奥列什基及其他受影响社区的安全、有效的人道主义走廊。",
      "demand2": "为人类狩猎袭击的受害者提供即时的人道主义救济和援助。",
      "demand3": "对袭击平民事件负有责任的个人和供应链实施适当制裁。",
      "demand4": "采取措施，遏制在赫尔松、乌克兰及其他地方使用小型无人机系统性地攻击和恐吓平民。",
      "cities": {
        "edinburgh": {
          "city": "爱丁堡",
          "country": "英国",
          "time": "爱丁堡 - 英国，14:00",
          "location": "Duke of Wellington Monument",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "birmingham": {
          "city": "伯明翰",
          "country": "英国",
          "time": "伯明翰 - 英国，14:00 - 16:00",
          "location": "Hall of Memory 对面，B1 2ND",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "vienna": {
          "city": "维也纳",
          "country": "奥地利",
          "time": "维也纳 - 奥地利，15:00 - 17:00",
          "location": "Stephansplatz, 1010 Wien",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule27"
        },
        "munich": {
          "city": "慕尼黑",
          "country": "德国",
          "time": "慕尼黑 - 德国，15:00 - 17:00",
          "location": "Marienplatz, 80331 München",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule3"
        },
        "london": {
          "city": "伦敦",
          "country": "英国",
          "time": "伦敦 - 英国，16:00 - 18:00",
          "location": "唐宁街",
          "cleanTime": "16:00 - 18:00",
          "day": "schedule27"
        },
        "manchester": {
          "city": "曼彻斯特",
          "country": "英国",
          "time": "曼彻斯特 - 英国，14:00 - 15:30",
          "location": "圣彼得广场（St Peter's Square）",
          "cleanTime": "14:00 - 15:30",
          "day": "schedule26"
        },
        "sydney": {
          "city": "悉尼",
          "country": "澳大利亚",
          "time": "悉尼 - 澳大利亚，14:00",
          "location": "悉尼市政厅（Sydney Town Hall）",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "paris": {
          "city": "巴黎",
          "country": "法国",
          "time": "巴黎 - 法国，15:30 - 18:30",
          "location": "从圣弗拉基米尔教堂到圣米歇尔广场",
          "cleanTime": "15:30 - 18:30",
          "day": "schedule26"
        },
        "parisSep30": {
          "city": "巴黎",
          "country": "法国",
          "time": "巴黎 - 法国，18:00",
          "location": "朗布托地铁站（Rambuteau）",
          "cleanTime": "18:00",
          "day": "schedule30"
        },
        "lyon": {
          "city": "里昂",
          "country": "法国",
          "time": "里昂 - 法国，14:00",
          "location": "喜剧广场（Place de la Comédie）",
          "cleanTime": "14:00",
          "day": "schedule27"
        },
        "dublin": {
          "city": "都柏林",
          "country": "爱尔兰",
          "time": "都柏林 - 爱尔兰，13:00",
          "location": "邮政总局（The GPO）",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "brussels": {
          "city": "布鲁塞尔",
          "country": "比利时",
          "time": "布鲁塞尔 - 比利时，10:00 - 11:00",
          "location": "La Petite rue de la Loi, 1040 布鲁塞尔（舒曼环岛）",
          "cleanTime": "10:00 - 11:00",
          "day": "schedule28"
        },
        "ottawa": {
          "city": "渥太华",
          "country": "加拿大",
          "time": "渥太华 - 加拿大，12:30 - 13:30",
          "location": "俄罗斯大使馆（285 Charlotte St）",
          "cleanTime": "12:30 - 13:30",
          "day": "schedule2"
        },
        "nantes": {
          "city": "南特",
          "country": "法国",
          "time": "南特 - 法国，15:00 - 16:30",
          "location": "皇家广场（Place Royale）",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule3"
        },
        "gdansk": {
          "city": "格但斯克",
          "country": "波兰",
          "time": "格但斯克 - 波兰，18:30 - 19:30",
          "location": "长市场（Długi Targ），海神喷泉旁",
          "cleanTime": "18:30 - 19:30",
          "day": "schedule27"
        },
        "chicago": {
          "city": "芝加哥",
          "country": "美国",
          "time": "芝加哥 - 美国，13:00",
          "location": "410 N. Michigan ave.（Wrigley 大厦）",
          "cleanTime": "13:00",
          "day": "schedule27"
        },
        "chicagoOct4": {
          "city": "芝加哥",
          "country": "美国",
          "time": "芝加哥 - 美国，13:00",
          "location": "410 N. Michigan ave.（Wrigley 大厦）",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "chicagoOct11": {
          "city": "芝加哥",
          "country": "美国",
          "time": "芝加哥 - 美国，13:00",
          "location": "410 N. Michigan ave.（Wrigley 大厦）",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "chicagoOct18": {
          "city": "芝加哥",
          "country": "美国",
          "time": "芝加哥 - 美国，13:00",
          "location": "410 N. Michigan ave.（Wrigley 大厦）",
          "cleanTime": "13:00",
          "day": "schedule18"
        },
        "dresden": {
          "city": "德累斯顿",
          "country": "德国",
          "time": "德累斯顿 - 德国，14:00",
          "location": "新市场（Neumarkt）",
          "cleanTime": "14:00",
          "day": "schedule4"
        },
        "malaga": {
          "city": "马拉加",
          "country": "西班牙",
          "time": "马拉加 - 西班牙，19:00",
          "location": "码头广场（Plaza de la Marina）",
          "cleanTime": "19:00",
          "day": "schedule3"
        },
        "londonSep29": {
          "city": "伦敦",
          "country": "英国",
          "time": "伦敦 - 英国，18:00",
          "location": "特拉法加广场",
          "cleanTime": "18:00",
          "day": "schedule29"
        },
        "plovdiv": {
          "city": "普罗夫迪夫",
          "country": "保加利亚",
          "time": "普罗夫迪夫 - 保加利亚，17:00",
          "location": "主街（Glavnata），卡梅尼察（Kamenitza）台阶旁 / “Together”字样处",
          "cleanTime": "17:00",
          "day": "schedule3"
        },
        "budapest": {
          "city": "布达佩斯",
          "country": "匈牙利",
          "time": "布达佩斯 - 匈牙利，17:00 - 20:00",
          "location": "Szent István tér（圣伊什特万广场）",
          "cleanTime": "17:00 - 20:00",
          "day": "schedule30"
        },
        "londonOct1": {
          "city": "伦敦",
          "country": "英国",
          "time": "伦敦 - 英国，17:00",
          "location": "特拉法加广场",
          "cleanTime": "17:00",
          "day": "schedule1"
        },
        "londonOct3": {
          "city": "伦敦",
          "country": "英国",
          "time": "伦敦 - 英国，12:00",
          "location": "特拉法加广场",
          "cleanTime": "12:00",
          "day": "schedule3"
        },
        "hamburg": {
          "city": "汉堡",
          "country": "德国",
          "time": "汉堡 - 德国，14:00 - 16:00",
          "location": "Landungsbrücken, Jan-Fedder-Promenade, 1号码头旁，20359 汉堡",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "kiel": {
          "city": "基尔",
          "country": "德国",
          "time": "基尔 - 德国，15:00 - 16:00",
          "location": "荷尔斯泰因大街（Holstenstraße）",
          "cleanTime": "15:00 - 16:00",
          "day": "schedule4"
        },
        "oslo": {
          "city": "奥斯陆",
          "country": "挪威",
          "time": "奥斯陆 - 挪威",
          "location": "埃兹沃尔广场（Eidsvolls plass）",
          "cleanTime": "",
          "day": "schedule3"
        },
        "leipzig": {
          "city": "莱比锡",
          "country": "德国",
          "time": "莱比锡 - 德国，17:00 - 18:00",
          "location": "中央火车站（Willy-Brandt-Platz）",
          "cleanTime": "17:00 - 18:00",
          "day": "schedule5"
        },
        "londonOct9": {
          "city": "伦敦",
          "country": "英国",
          "time": "伦敦 - 英国，17:00",
          "location": "特拉法加广场",
          "cleanTime": "17:00",
          "day": "schedule9"
        },
        "londonOct10": {
          "city": "伦敦",
          "country": "英国",
          "time": "伦敦 - 英国，13:00",
          "location": "特拉法加广场",
          "cleanTime": "13:00",
          "day": "schedule10"
        },
        "dublinOct11": {
          "city": "都柏林",
          "country": "爱尔兰",
          "time": "都柏林 - 爱尔兰，13:00",
          "location": "邮政总局（The GPO）",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "dublinOct25": {
          "city": "都柏林",
          "country": "爱尔兰",
          "time": "都柏林 - 爱尔兰，14:00",
          "location": "邮政总局（The GPO）",
          "cleanTime": "14:00",
          "day": "schedule25"
        },
        "nantesOct31": {
          "city": "南特",
          "country": "法国",
          "time": "南特 - 法国，15:00 - 16:30",
          "location": "皇家广场（Place Royale）",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule31"
        }
      },
      "posterStopSiege": "停止俄罗斯无人机围困",
      "posterNoRoadOut": "进出奥列什基的道路已被封锁",
      "posterHumanitarianCatastrophe": "奥列什基：占领下的人道主义灾难",
      "seeGallery": "查看 / 下载海报"
    },
    "artBy": "作者：{{name}}",
    "downloadPoster": "下载海报",
    "reel": {
      "download": "下载视频（MP4）"
    },
    "addDemo": {
      "title": "添加您的示威活动",
      "where": "地点：城镇/城市",
      "contact": "邮箱/号码",
      "message": "留言：您代表哪个团体，示威活动已确认或筹备中，在线公告链接，其他详情",
      "submit": "提交",
      "sending": "发送中…",
      "thanks": "谢谢！我们会与您联系。",
      "error": "出现问题，请重试。",
      "contactInvalid": "请输入有效的邮箱，或带国家代码的电话号码（例如 +44 7700 900123）。",
      "date": "日期",
      "time": "开始时间（当地）",
      "whereInvalid": "请输入城镇或城市名称，例如 巴黎 或 基辅，乌克兰。",
      "datePlaceholder": "日期：日/月"
    }
  },
  "seo": {
    "oleshky": {
      "title": "停止无人机围困——拯救奥列什基｜全球示威",
      "description": "俄罗斯无人机围困着乌克兰被占领的奥列什基的数千名平民，他们被切断了食物、水和药品。查找您附近的示威活动，要求开辟安全通道。"
    },
    "leftBank": {
      "title": "奥列什基及被占领赫尔松州的无人机围困",
      "description": "数千名平民被困在被占领的奥列什基、霍拉普里斯坦及附近村庄，遭受俄罗斯无人机围困。了解正在发生的事情以及您可以如何提供帮助。"
    },
    "help": {
      "title": "停止“人类狩猎”——俄罗斯无人机在赫尔松猎杀平民",
      "description": "俄罗斯无人机在乌克兰赫尔松猎杀平民。了解“人类狩猎”这一战争罪行，以及您可以如何帮助制止它。"
    },
    "action": {
      "title": "2025年12月全球集会——停止“人类狩猎”",
      "description": "2025年12月全球集会的照片、海报和地点，抗议俄罗斯无人机袭击乌克兰赫尔松平民。"
    },
    "rallies": {
      "title": "集会照片——停止“人类狩猎”",
      "description": "世界各地抗议俄罗斯无人机袭击乌克兰赫尔松平民的集会照片。"
    },
    "resources": {
      "title": "“人类狩猎”资料——报告、文章与证词",
      "description": "关于俄罗斯无人机袭击乌克兰赫尔松平民的报告、文章、采访和目击者证词。"
    },
    "reel": {
      "title": "拯救奥列什基——示威视频",
      "description": "2026年10月全球“拯救奥列什基”示威活动的视频。"
    }
  }
}
